import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";
import { subscribeNewsletter } from "../services/newsletterService";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    const value = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setError("Enter a valid email address.");
      return;
    }
    setSubmitting(true);
    try {
      const result = await subscribeNewsletter(value);
      setMessage(result.message || "Thanks for subscribing.");
      setEmail("");
    } catch (err) {
      setError(err?.response?.data?.detail || "Could not subscribe right now.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="mt-12 border-t border-white/10 bg-black px-4 py-12 md:mt-16 md:px-8 md:py-14 lg:px-12" data-testid="footer">
      <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
        <div className="col-span-2">
          <div className="font-anton text-5xl uppercase md:text-6xl">
            CYNOS<span className="text-cynos-red">.</span>
          </div>
          <p className="mt-4 max-w-md text-sm text-zinc-400">
            Premium streetwear tees built for the bold. Designed in India, dropped in limited runs. Wear your attitude.
          </p>
          <form onSubmit={onSubmit} className="mt-6 max-w-md" data-testid="newsletter-form">
            <div className="flex rounded-[8px] border border-white/15 bg-cynos-surface">
              <input
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="EMAIL FOR DROP ALERTS"
                className="min-w-0 flex-1 bg-transparent px-4 py-3 font-mono text-xs uppercase tracking-[0.18em] outline-none placeholder:text-zinc-600"
                data-testid="newsletter-email"
              />
              <button
                type="submit"
                disabled={submitting}
                className="border-l border-white/15 px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] transition hover:bg-white hover:text-black disabled:opacity-50"
                data-testid="newsletter-submit"
              >
                {submitting ? "Joining" : "Join"}
              </button>
            </div>
            {(message || error) && (
              <p className={`mt-3 font-mono text-[10px] uppercase tracking-[0.16em] ${error ? "text-red-300" : "text-emerald-300"}`}>
                {error || message}
              </p>
            )}
          </form>
          <div className="mt-6 flex gap-4">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-white hover:text-cynos-red" data-testid="footer-instagram"><Instagram size={20} /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-white hover:text-cynos-red" data-testid="footer-twitter"><Twitter size={20} /></a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" className="text-white hover:text-cynos-red" data-testid="footer-youtube"><Youtube size={20} /></a>
          </div>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs uppercase tracking-[0.2em] text-white">Shop</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/shop?category=men" className="hover:text-white">Men</Link></li>
            <li><Link to="/shop?category=women" className="hover:text-white">Women</Link></li>
            <li><Link to="/shop?category=unisex" className="hover:text-white">Unisex</Link></li>
            <li><Link to="/shop?category=couple" className="hover:text-white">Couple Tees</Link></li>
            <li><Link to="/shop?category=oversized" className="hover:text-white">Oversized</Link></li>
            <li><Link to="/shop?category=custom" className="hover:text-white">Custom</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs uppercase tracking-[0.2em] text-white">Customer Care</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/profile" className="hover:text-white">Profile</Link></li>
            <li><Link to="/shipping-returns" className="hover:text-white">Shipping & Returns</Link></li>
            <li><Link to="/size-guide" className="hover:text-white">Size Guide</Link></li>
            <li><Link to="/why-choose-cynos" className="hover:text-white">Why Choose Cynos</Link></li>
            <li><Link to="/track-order" className="hover:text-white">Track Order</Link></li>
            <li><Link to="/custom-design" className="hover:text-white">Custom Design</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 md:flex-row">
        <span>&copy; {new Date().getFullYear()} Cynos. All rights reserved.</span>
        <span>Made in India - Free shipping pan-India</span>
      </div>
    </footer>
  );
};

export default Footer;
